import http from "@/utils/request";

const product = {
  // 商品列表
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.querySku4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 新增商品
  addProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.addProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 复制商品
  copyProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.copyProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 删除商品
  deleteProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.deleteProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 导出商品
  exportSkuInfo: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.exportSkuInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 商品停止供货
  stopSupplyProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.stopSupplyProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 编辑商品
  updateProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.updateProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 商品供货接口
  supplyProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.supplyProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 解禁商品接口
  unLockProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.stopSupplyProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  // 禁用商品接口
  lockProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.stopSupplyProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
      },
    }),
  submitDownloadBatchStockTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.submitDownloadBatchStockTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  previewBatchImportProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.previewBatchImportProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        16000002: "上传的Excel文件内容为空",
      },
    }),
  batchImportProduct: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.batchImportProduct",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        16000002: "上传的Excel文件内容为空",
      },
    }),
  getSkuDetail: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.getSkuDetail",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        16000002: "上传的Excel文件内容为空",
      },
    }),
  updateSkuExtend: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderSkuService.skuExtendOverride",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        10000001: "内部异常",
        16000002: "上传的Excel文件内容为空",
      },
    }),
  queryProductDeclare: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderProductDeclareService.queryProductDeclare4Page",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        14000001: "内部异常",
      },
    }),
  downloadProductDeclare: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderProductDeclareService.exportProductDeclareInfo",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        14000001: "内部异常",
      },
    }),
};

export default product;
